import "./StatsTop.css"

const StatsTop = ({ stats }) => {
  return (
    <div className="top-stats">
      <div className="stat-card"><h2>Total Txns</h2><p>{stats.totalTransactions}</p></div>
      <div className="stat-card"><h2>Scrips</h2><p>{stats.uniqueScripsCount}</p></div>
      <div className="stat-card"><h2>Quantity</h2><p>{stats.totalScripQuantity}</p></div>
      <div className="stat-card"><h2>Payable Amount</h2><p>{stats.totalBillAmount}</p></div>
      <div className="stat-card"><h2>Receivable Amount</h2><p>{stats.totalReceivableAmount}</p></div>
      <div className="stat-card"><h2>Commission</h2><p>{stats.totalCommission}</p></div>

      <div className="stat-card">
        <h2>{stats.grossNetProfitLoss > 0 ? "Gross Profit" : "Gross Loss"}</h2>
        <p>{stats.grossNetProfitLoss}</p>
      </div>

      <div className="stat-card">
        <h2>Capital Gain (7.5%)</h2>
        <p>{stats.totalCapitalGain}</p>
      </div>

      <div className="stat-card">
        <h2>{stats.netProfitLoss > 0 ? "Net Profit" : "Net Loss"}</h2>
        <p>{stats.netProfitLoss}</p>
      </div>

      <div className="stat-card">
        <h2>Profit %</h2>
        <p className={
          stats.totalBillAmount > 0
            ? (stats.netProfitLoss / stats.totalBillAmount) * 100 >= 0
              ? "profit"
              : "loss"
            : ""
        }>
          {stats.totalBillAmount > 0
            ? ((stats.netProfitLoss / stats.totalBillAmount) * 100).toFixed(2) + "%"
            : "0.00%"}
        </p>
      </div>
    </div>
  );
};

export default StatsTop;